import { render } from "./Doughva.vue?vue&type=template&id=64b5dbc2"
import script from "./Doughva.vue?vue&type=script&lang=js"
export * from "./Doughva.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__